import { CLICK_ID_KEYS, UTM_KEYS } from "@purlink/shared/attribution";

/**
 * Pages that load Google Analytics and the Meta Pixel. Public pages only: staff
 * pages (lead IDs in the URL) and the sign-in flow (reset tokens) never do.
 */
const TRACKED_PATHS = new Set(["/enquire", "/enquire/thanks", "/privacy"]);
const KEPT_PARAMS: readonly string[] = [...UTM_KEYS, ...CLICK_ID_KEYS];

export function isTrackedPath(pathname: string): boolean {
  return TRACKED_PATHS.has(pathname.replace(/\/+$/, "") || "/");
}

/** Origin and path plus campaign parameters only, so nothing else in the query is sent. */
export function sanitizeLocation(href: string): string {
  const url = new URL(href);
  const kept = new URLSearchParams();
  for (const [key, value] of url.searchParams) {
    if (KEPT_PARAMS.includes(key)) kept.append(key, value);
  }
  const query = kept.toString();
  return `${url.origin}${url.pathname}${query ? `?${query}` : ""}`;
}
